import Lista from './Lista';

export const AulaLista = Lista;
